import { createMuiTheme } from "@material-ui/core";

const mainTheme = createMuiTheme({
    palette: {
      primary: {
        main: '#1FA19D'
      },
      secondary: {
        main: '#4A618A'
      },
    },
    typography: {
      fontFamily: 'Source Sans Pro, Roboto, sans-serif'
    }
  });

  export default mainTheme;